import type { ReactElement } from 'react';
import {
  IconAdjustments,
  IconFlag,
  IconForms,
  IconHistory,
  IconKey,
  IconLanguage,
  IconListDetails,
  IconShieldCheck,
  IconUserCheck,
  IconUsers,
} from '@tabler/icons-react';

const icon = (Component: typeof IconKey): ReactElement => <Component size={20} strokeWidth={1.5} />;

export const SECTION_ICONS: Record<string, ReactElement> = {
  roles: icon(IconShieldCheck),
  permissions: icon(IconKey),
  applicationAccess: icon(IconUserCheck),
  users: icon(IconUsers),
  featureFlags: icon(IconFlag),
  parameters: icon(IconAdjustments),
  valueLists: icon(IconListDetails),
  translations: icon(IconLanguage),
  customFields: icon(IconForms),
  auditLog: icon(IconHistory),
};
